import * as enums from '../../enums';
import cx from 'classnames';
import s from './styles.scss';
import { ButtonAnchorProps } from './types';

export const ButtonAnchor = ({
  children,
  className,
  variant = enums.Variant.DEFAULT,
  color = enums.ColorTheme.PRIMARY,
  size = enums.Size.MEDIUM,
  disabled = false,
  hasError = false,
  ...restProps
}: ButtonAnchorProps): JSX.Element => {
  const buttonCx = cx(
    s.button,
    s[size],
    s[variant],
    s[color],
    { [s.disabled]: disabled },
    { [s.error]: hasError },
    className
  );

  return (
    <a
      role="button"
      className={buttonCx}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      {...restProps}
    >
      {children}
    </a>
  );
};
